import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@cdm/quickenloans-library/lib';

import PostGrid from '../../PostGrid';
import { testAttributes, defaultAttributes } from '../Constants';
import * as styles from '../GridContainer.module.scss';

const ScrollPagination = ({
    queryArgs = {},
    gridLimit = 12, 
    btnLabel = defaultAttributes.button_label,
    titleTag = defaultAttributes.titleTag, 
    showControl = true 
}) => 
{
    const { posts, total_found: totalFound } = queryArgs;
    const [visibleData, setVisibleData] = useState(posts?.slice(0, gridLimit));
    const [currentPage, setCurrentPage] = useState(gridLimit);

    const handlePage = () => 
    {
        const newPage = currentPage + gridLimit;
        setCurrentPage(newPage);
        setVisibleData(visibleData.concat(posts.slice(currentPage, newPage)));
    };

    const GridComponents = useMemo(() => 
    {
        const grids = [];
        const numericGridLimit = Number(gridLimit);
        for (let i = 0; i < visibleData.length; i += numericGridLimit) 
        {
            grids.push(
                <PostGrid
                    key={`post-grid-starting-${i}`}
                    posts={visibleData?.slice(i, i + numericGridLimit)}
                    postLimit={gridLimit}
                    titleTag={titleTag}
                />
            );
        }
        return grids;
    }, [visibleData]);

    return (<>
        {GridComponents}
        <div className={styles.paginateButtonContainer}>
            {
                showControl && currentPage < totalFound - 1 && (
                    <Button 
                        // eslint-disable-next-line react/style-prop-object
                        style="filled"
                        onClick={handlePage}
                        testId={testAttributes.GRID_POST_SEE_MORE}
                        color="green"
                    >
                        <span>{btnLabel}</span>
                    </Button>
                )
            }
        </div>
    </>)
};

ScrollPagination.propTypes = {
    /** Object with post arrays and total post */
    queryArgs: PropTypes.oneOfType([PropTypes.object]),
    /** Number of post to paginate, default 6 */
    gridLimit: PropTypes.number,
    /** Label for Button component */
    btnLabel: PropTypes.string,
    /** titleTag for card title default h3 */
    titleTag: PropTypes.string,
    /** showControl boolean to show see more button default(true) */
    showControl: PropTypes.bool,
};

export default ScrollPagination;